import { useEffect } from 'react';
import { Outlet, useLocation, useParams } from 'react-router-dom';

import { Toaster } from '@/components/ui/sonner';
import { FooterProvider } from '@/hooks/useFooterContext';
import { SidebarProvider, useSidebar } from '@/hooks/useSidebarContext';
import {
  setLastAppLocation,
  setLastVisitedWorkspaceUname,
} from '@/utils/lastWorkspaceSession';
import { WorkspaceValidator } from '../error/WorkspaceValidator';
import { Sidebar } from './Sidebar';

function LayoutContent() {
  const { workspaceUname } = useParams<{ workspaceUname: string }>();
  const location = useLocation();
  const { isCollapsed, toggleSidebar } = useSidebar();

  useEffect(() => {
    if (workspaceUname) {
      setLastVisitedWorkspaceUname(workspaceUname);
      setLastAppLocation(location.pathname, location.search);
    }
  }, [workspaceUname, location.pathname, location.search]);

  return (
    <div className="flex h-screen bg-background">
      <Sidebar isCollapsed={isCollapsed} onToggle={toggleSidebar} />
      <main className="flex-1 flex flex-col overflow-hidden">
        <div className="flex-1 overflow-y-auto">
          <Outlet />
        </div>
        <Toaster />
      </main>
    </div>
  );
}

export function Layout() {
  return (
    <WorkspaceValidator>
      <SidebarProvider>
        <FooterProvider>
          <LayoutContent />
        </FooterProvider>
      </SidebarProvider>
    </WorkspaceValidator>
  );
}
